/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Microsoft_Tenant_Status_SetInputs */



/**
* | output |
* | --- |
* | "Set: Microsoft sign-in only accepts accounts from this tenant." |
*
* @param {Microsoft_Tenant_Status_SetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const microsoft_tenant_status_set = /** @type {((inputs?: Microsoft_Tenant_Status_SetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Microsoft_Tenant_Status_SetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Festgelegt: Die Microsoft-Anmeldung akzeptiert nur Konten aus diesem Mandanten.")
	return /** @type {LocalizedString} */ ("Set: Microsoft sign-in only accepts accounts from this tenant.")
});